import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = { auth: [...authRoles.admin, ...authRoles.hauling], routes: [{ path: '/driver-performance', component: FuseLoadable({ loader: () => import('./DriverPerformanceApp') }) }] };

export default [Index];
